module.exports = __webpack_public_path__ + "img/undone.31e3512d.svg";